// extracted by mini-css-extract-plugin
module.exports = {"Image":"LandingPageParagraphSection-module--Image--1Un3m"};